import styled from 'styled-components'
import { white, gray } from '@bufferapp/ui/style/colors'

import { flexCol } from '~/shared/styles/layout'

/**
 *
 */

export const Wrapper = styled.dialog`
  ${flexCol}
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(29, 29, 29, 0.7);
  z-index: 99;
  border: none;
`

export const ContentWrapper = styled.div`
  width: 512px;
  margin: 80px 0px;
  background: ${white};
  border: 1px solid ${gray};
  box-shadow: 1px 3px 3px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
`
